import React from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '@src/languages';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import CustomTypography from '@src/new-components/Typography';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import { Typography } from '@mui/material';
import SrtIcon from '@src/assets/images/srt-icon.svg';
import SrtFileIcon from '@src/assets/icons/srt-file.svg';
import { getShortFileName } from '@src/services/file';
import DirectBoxSendIcon from '@src/assets/icons/directbox-send.svg';
import { convertSecondsToHMS } from '@src/utils/time';
import {
  StyledDefaultDropzoneContent,
  StyledSuccessDropzoneContent,
} from './index.style';
import FileSelected from './FileSelected';
import SampleFileReference from './SampleFileReference';

const SuccessDropzoneContent = ({
  fileName,
  totalCharacters = 0,
  totalSeconds = 0,
  isProcessDubbingByUnitSecond = false,
  fileFormat,
  handleResetFile,
  isMultipleInputDubbing,
}) => {
  const { t } = useTranslation();
  const { language } = i18n;
  const location = useLocation();
  const isCreateSrtProjectPage = location.pathname.includes('/projects');
  const { user } = useSelector((state) => state.auth);

  const { getFeatureValue } = useFeatureFlags();

  const createSrtProjectEnabled = getFeatureValue(
    FEATURE_KEYS.CREATE_SRT_PROJECT,
    {
      userId: user.id,
      email: user.email,
      phoneNumber: user.phoneNumber,
    },
  );

  const renderCharacterCount = () => (
    <div className="total-characters">
      <Typography variant="h5" className="total-characters-text">
        {t('totalCharacters')}:
      </Typography>
      <Typography variant="h5" className="total-characters-number">
        {totalCharacters?.toLocaleString(language)}
      </Typography>
    </div>
  );

  const renderSecondsCount = () => (
    <div className="total-characters">
      <Typography variant="h5" className="total-characters-text">
        {t('duration')}:
      </Typography>
      <Typography variant="h5" className="total-characters-number">
        {convertSecondsToHMS(totalSeconds)}
      </Typography>
    </div>
  );

  const renderRequestResource = () => {
    if (isProcessDubbingByUnitSecond) return renderSecondsCount();

    return (
      <div className="recourse-request">
        {renderCharacterCount()}
        {renderSecondsCount()}
      </div>
    );
  };

  const OldDropzone = () => {
    const showSrtProjectUI = createSrtProjectEnabled && isCreateSrtProjectPage;

    return (
      <>
        <img src={showSrtProjectUI ? SrtIcon : SrtFileIcon} alt="srt-icon" />

        {showSrtProjectUI ? (
          <CustomTypography variant="body-16-medium" color="#101323">
            {getShortFileName(fileName)}
          </CustomTypography>
        ) : (
          <Typography className="file-name">
            {getShortFileName(fileName)}
          </Typography>
        )}

        {showSrtProjectUI ? (
          <>
            <CustomTypography
              align="center"
              variant="body-14-regular"
              color="#1C1C1EA3"
            >
              {t('selectAndDragChangeFileSrt')}
            </CustomTypography>
          </>
        ) : (
          <Typography align="center" variant="h5" className="upload-file-title">
            {t('dropFileSuccessInstruct', { fileFormat })}
          </Typography>
        )}

        {renderRequestResource()}
      </>
    );
  };

  const NewDropzone = () => (
    <StyledDefaultDropzoneContent>
      <img src={DirectBoxSendIcon} alt="srt-icon" />
      <div className="upload-instruction">
        <Typography
          align="center"
          variant="h5"
          className="upload-file-title text-blue"
        >
          {t('dropFileSuccessInstructSubtitle', { fileFormat })}
        </Typography>
        <SampleFileReference isMultipleInputDubbing />
      </div>
      {fileName?.length > 0 && (
        <FileSelected fileName={fileName} handleResetFile={handleResetFile} />
      )}
    </StyledDefaultDropzoneContent>
  );

  return (
    <StyledSuccessDropzoneContent>
      {isMultipleInputDubbing ? <NewDropzone /> : <OldDropzone />}
    </StyledSuccessDropzoneContent>
  );
};

export default SuccessDropzoneContent;
